export const languageList = ['English', 'French']
export const semesterStatusList = [
    { key: 'OPEN', value: 1 },
    { key: 'CLOSED', value: 2 },
]
